import React from 'react';

export const getRoleSimpleList = () => ['user', 'admin', 'developer', 'owner'];
export const getRoleList = () => ['user (Active)', 'user (Passive)', 'admin', 'developer', 'owner'];

export const getRoleDescription = (role) => {
  switch (role) {
    case 'user (Active)':
      return (
        <div>
          Users with this role can access to dashboards and features,
          interact with workflows, and do other general actions in the organization.
          <div>
            <small>For Active and Passive users</small>
          </div>
        </div>
      );
    case 'user (Passive)':
      return (
        <div>
          Users with this role can access the dashboards,
          view workflows, and receive notifications for their workflows subscriptions
          <div>
            <small>For Active and Passive users</small>
          </div>
        </div>
      );
    case 'admin':
      return (
        <div>
          Users with this role can access the settings pages
          (workflows, events, forms, subscriptions).
          <div>
            <small>Only for Active users</small>
          </div>
        </div>
      );
    case 'developer':
      return (
        <div>
          Users with this role can access the developer page and
          the API key to interact with your Pingum organization from a 3rd party software.
          <div>
            <small>Only for Active users</small>
          </div>
        </div>
      );
    case 'owner':
      return (
        <div>
          Users with this role can access billing information
          and other sensitive features for the organization.
          <div>
            <small>Only for Active users</small>
          </div>
        </div>
      );
    default:
      return <div>Not a valid role</div>;
  }
};

export const getRoleFeatures = (role) => {
  switch (role) {
    case 'user (Active)':
      return ['View Dashboards', 'Initiate Workflows', 'Update Workflows', 'Change Workflow Status', 'Comment On Workflows', 'Subscribe to Workflows', 'Get Notified of Workflows'];
    case 'user (Passive)':
      return ['View Dashboards', 'Subscribe to Workflows', 'Get Notified of Workflows'];
    case 'admin':
      return ['Same Features as User Plus...', 'Add or Remove Users From Organization', 'Create or Workflow Settings', 'Create or Update Event Settings', 'Create or Update Forms', 'Create or Update Workflows'];
    case 'developer':
      return ['Access Developers Page', 'View and Reset Organization API Key'];
    case 'owner':
      return ['Same Features as User and Admin Plus...', 'Update Organization Settings', 'Update Organization Billing Information'];
    default:
      return ['Not a valid role'];
  }
};

export const formatStringOfRolesIntoArray = (rolesString) => {
  if (rolesString === undefined) {
    return [];
  }
  let parsedRoleString = rolesString.replace('[', '');
  parsedRoleString = parsedRoleString.replace(']', '');
  parsedRoleString = parsedRoleString.replace(/\s/g, '');
  return parsedRoleString.split(',');
};
